import React, {useEffect, useState } from "react";
import CoreColors from "./CoreColors";
import axios from "axios";
import { Link } from "react-router-dom";




export default function Header() {
  const [categories, setCategories] = useState([]);


  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(API_URL + "categories")
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error("Failed to load categories", err);
      });
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 sticky-top">
      <div className="container-fluid">

        {/* LOGO */}
        <Link className="navbar-brand" to="/">
          <img src="/brooksroyale-logo.jpg" width="200" alt="Logo" />
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* NAVIGATION */}
        <div className="collapse navbar-collapse justify-content-center" id="mainNav">
          <ul className="navbar-nav mx-auto nav-custom">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item dropdown">
  <a
    className="nav-link dropdown-toggle"
    href="#"
    id="hospitalityDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Hospitality
  </a>

  <ul className="dropdown-menu" aria-labelledby="hospitalityDropdown">
    <li>
      <h6 className="dropdown-header">Products</h6>
    </li>
    <li>
      <Link className="dropdown-item" to="/hospitality/bed-linen">
        Bed Linen
      </Link>
    </li>
    <li>
      <Link className="dropdown-item" to="/hospitality/bath-linen">
        Bath Linen
      </Link>
    </li>

    <li><hr className="dropdown-divider" /></li>

    <li>
      <h6 className="dropdown-header">Materials</h6>
    </li>
    <li>
      <Link className="dropdown-item" to="/hospitality/about-linen">
        About Linen
      </Link>
    </li>
  </ul>
</li>


            {categories.map((cat) => (
            <li className="nav-item" key={cat.id}>
              <Link className="nav-link" to={`/categories/${cat.slug}`}>
                {cat.name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
              </Link>
            </li>
            
          ))}
          </ul>
        </div>

      </div>
    </nav>
  );
}
